import { Paiement, PaiementInfo, Contrat } from "../../model/Model";
import { del, get, post, put } from "../api";
import axios from 'axios';
import { getStoredAccessToken } from '../auth/auth.service';

export async function getPaiements(): Promise<PaiementInfo[]> {
    try {
        const response = await get('/v1/paiements');
        return response.data?.data || [];
    } catch (error) {
        console.error('Erreur lors de la récupération des paiements:', error);
        return [];
    }
}

export async function getPaiementById(id: number): Promise<Paiement | null> {
    try {
        const response = await get(`/v1/paiements/${id}`);
        return response.data?.data;
    } catch (error) {
        console.error(`Erreur lors de la récupération du paiement avec l'id ${id}:`, error);
        return null;
    }
}

export async function ajouterPaiement(paiement: Paiement): Promise<Paiement> {
    try {
        const response = await post('/v1/paiements', paiement);
      
        return response.data?.data || {};
    } catch (error) {
        console.error('Erreur lors de l\'ajout du paiement:', error);
        throw error;
    }
}

export async function modifierPaiement(paiement: Paiement): Promise<Paiement> {
    try {
        const response = await put('/v1/paiements', paiement);
        return response.data?.data;
    } catch (error) {
        console.error('Erreur lors de la modification du paiement:', error);
        throw error;
    }
}

export async function supprimerPaiement(paiementId: number): Promise<void> {
    try {
        await del(`/v1/paiements/${paiementId}`);  
    } catch (error) {
        console.error('Erreur lors de la suppression du paiement:', error);
        throw error;
    }   
}

export async function getContratsActifs(): Promise<Contrat[]> {
    try {
        const response = await get('/v1/contrats?statut=ACTIF');
      
        return response.data?.data || [];
    } catch (error) {
        console.error('Erreur lors de la récupération des contrats actifs:', error);
        return [];
    }
}

/**
 * Télécharge le reçu PDF d'un paiement depuis le backend
 */
export async function telechargerRecuPaiement(paiementId: number): Promise<void> {
    try {
        const baseUrl = window.origin;
        const token = getStoredAccessToken();
        
        const response = await axios.get(`${baseUrl}/api/v1/paiements/${paiementId}/recu`, {
            headers: {
                'Authorization': `Bearer ${token}`
            },
            responseType: 'blob' // Important pour recevoir un fichier binaire
        });
        
        // Créer un lien de téléchargement temporaire
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `recu_paiement_${paiementId}.pdf`;
        
        // Déclencher le téléchargement
        document.body.appendChild(link);
        link.click();
        
        // Nettoyer
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        
        console.log(`Reçu PDF téléchargé avec succès pour le paiement #${paiementId}`);
    } catch (error) {
        console.error('Erreur lors du téléchargement du reçu PDF:', error);
        throw new Error('Impossible de télécharger le reçu. Veuillez réessayer.');
    }
}
